import { Card, SectionHeader, ConfidenceBar } from "../../components/lib";
import { LAUNCH_PROJECTS, CHECKLIST } from "../../mocks/launchData";

export default function LaunchControl() {
  return (
    <div className="space-y-6" data-testid="ln-control">
      {LAUNCH_PROJECTS.map((l) => {
        const items = CHECKLIST.filter((c) => c.launchId === l.id);
        const done = items.filter((c) => c.status === "done").length;
        const total = items.length;
        return (
          <Card key={l.id} testId={`ln-ctl-${l.id}`}>
            <div className="flex items-baseline justify-between mb-3">
              <div>
                <div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>{l.codename}</div>
                <div style={{ fontFamily: "var(--ph-display-font)", fontSize: "1.2rem", color: "var(--ph-ink-strong)" }}>{l.productName}</div>
              </div>
              <div className="text-right">
                <div className="text-sm tabular-nums" style={{ color: "var(--ph-ink-strong)" }}>Target · {l.targetDate}</div>
                <div className="text-[10px]" style={{ color: "var(--ph-ink-muted)" }}>{l.daysToLaunch} days · {l.phase}</div>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
              <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Readiness</div>
                <div className="mt-1"><ConfidenceBar value={l.readinessPct/100}/></div>
                <div className="text-[10px] tabular-nums mt-0.5" style={{ color: "var(--ph-ink-muted)" }}>{l.readinessPct}%</div>
              </div>
              <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Budget</div>
                <div className="text-sm tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>EGP {(l.spentEGP/1000).toFixed(0)}K / {(l.budgetEGP/1000).toFixed(0)}K</div>
              </div>
              <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Pre-orders</div>
                <div className="text-sm tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{l.preOrderCurrentUnits}/{l.preOrderTargetUnits}</div>
              </div>
              <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Checklist</div>
                <div className="text-sm tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{done}/{total}</div>
              </div>
            </div>
            <div className="text-sm p-3" style={{ background: "var(--ph-ai-tint)", borderRadius: "var(--ph-radius-md)", color: "var(--ph-ink-default)" }}>
              <span className="text-[10px] uppercase tracking-[0.14em] mr-2" style={{ color: "var(--ph-ai)" }}>AI · Launch narrative</span>{l.narrative}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
